import { createQueryKey } from '../../../query/createQueryKeyFactory';
import { QueryKey } from '../../../query/types';

const consumerListsKeys = <T extends QueryKey>(keys: T) =>
  createQueryKey({
    all: [...keys] as const,
  });

export { consumerListsKeys };
